import primevue from 'primevue/config'
import Carousel from 'primevue/carousel'

export default defineNuxtPlugin(nuxtApp => {
    nuxtApp.vueApp.use(primevue, { ripple: true })
    nuxtApp.vueApp.component( Carousel )
})